export const TOKENS = {
  navyDeep:  "#0A1F3A",
  navyMid:   "#123159",
  navySoft:  "#1D4373",
  gold:      "#C9A227",
  goldLight: "#E8C878",
  goldPale:  "#F5EDCC",
  cream:     "#F7F4EC",
  ink:       "#1A1A1A",
  success:   "#3C8C5C",
  successBg: "#E7F1EA",
  danger:    "#B8462C",
  dangerBg:  "#FBEFE9",
  warning:   "#D4820A",
  warningBg: "#FEF3E2",
  blue:      "#2563EB",
  blueBg:    "#EFF6FF",
  muted:     "#8A8578",
  border:    "#EFEAE0",
  bgPage:    "#DDD8CB",
};

export const FONT_IMPORT = `@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600;9..144,700&family=Inter:wght@400;500;600;700;800&display=swap');`;
